import React, { useEffect, useState, useMemo } from 'react';
import Modal from '@/react/libraries/Modal';
import axios from 'axios';
import QCUser from './QCUser';

function QCUsersModal({ modalRef, onSubmit }) {
	const [users, setUsers] = useState([]);
	const [search, setSearch] = useState('');

	useEffect(() => {
		axios
			.get(`${BASE_URL}admin/qc/members`, { headers: window.HEADER_OBJ })
			.then(({ data }) => setUsers(data));
	}, []);

	// Compute a filtered list every time `users` or `search` changes.
	const filteredUsers = useMemo(
		() =>
			users.filter(u =>
				`${u.name ?? ''} ${u.email ?? ''}`
					.toLowerCase()
					.includes(search.toLowerCase()),
			),
		[users, search],
	);

	return (
		<Modal
			ref={modalRef}
			className="modal__content-wrapper w-[80vw] max-w-[900px]"
		>
			<div className="modal__content-wrapper-header px-2">
				<h2>Assign back to QC</h2>
			</div>

			<div className="modal__content-wrapper-body px-2">
				{/* ── Search field ─────────────────────────────────────── */}
				<input
					type="text"
					placeholder="Search users…"
					value={search}
					onInput={e => setSearch(e.target.value)}
					className="input-field"
				/>

				{/* ── Radio-group list ─────────────────────────────────── */}
				<div className='overflow-y-auto max-h-[60vh] pr-2'>
					<div className="border-normal rounded-primary border-grey p-4 grid grid-cols-2 gap-4">
						{filteredUsers.length > 0 ? (
							filteredUsers.map(user => (
								<label key={user.id} className="flex items-center gap-2">
									<input type="radio" name="qc_user" value={user.id} />
									<QCUser user={user} />
								</label>
							))
						) : (
							<div className="col-span-2 text-center text-gray-500 italic">
								No users found
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="modal__content-wrapper-footer px-2">
				<button
					className="btn btn-outline-primary"
					onClick={modalRef.current?.closeModal}
				>
					Cancel
				</button>
				<button
					className="btn"
					onClick={() => {
						const selected = document.querySelector(
							'input[name="qc_user"]:checked',
						);
						if (selected) onSubmit(selected.value);
					}}
				>
					Assign
				</button>
			</div>
		</Modal>
	);
}

export default QCUsersModal;
